// 将Tree的数据编码为DAT格式文本

/**
 * 从 parsedTreeData（Ant Design Tree 格式）还原为 .dat 文件内容
 * @param {Array} treeData - 修改后的 parsedTreeData
 * @returns {string} - 生成的 .dat 文件内容
 */
export const encodeDAT = (treeData) => {
    const sectionsMap = new Map(); // Map<fullSectionName, { [key]: value }>

    const traverse = (nodes, path = []) => {
        if (!Array.isArray(nodes)) return;

        for (const node of nodes) {
            if (node.isLeaf) {
                // 叶子节点：解析 key=value
                const match = node.title.match(/^([^=]+)=(.*)$/);
                if (match) {
                    const key = match[1].trim();
                    const value = match[2].trim();
                    const fullSectionName = path.join(':');

                    if (!sectionsMap.has(fullSectionName)) {
                        sectionsMap.set(fullSectionName, {});
                    }
                    sectionsMap.get(fullSectionName)[key] = value;
                }
            } else {
                // 非叶子节点：递归，路径追加当前 title
                traverse(node.children, [...path, node.title]);
            }
        }
    };

    traverse(treeData);

    // 按 section 出现顺序（Map 保持插入顺序）生成 .dat 内容
    const lines = [];
    for (const [sectionName, data] of sectionsMap.entries()) {
        lines.push(`[${sectionName}]`);
        for (const [key, value] of Object.entries(data)) {
            lines.push(`${key}=${value}`);
        }
        // lines.push(''); // 空行分隔（可选）
    }

    return lines.join('\n').trim(); // 去掉末尾多余空行
};